import { useStore } from '@/components/common/store';
import { computed } from 'vue';
import { pluralize } from '@/js/utils/utils';
import { HOTEL_LABELS } from '@global-js/constants';
import type { SearchFormDataType } from '@/interfaces/search-form';

export function useSelectedDestination() {
	const store = useStore();

	const formData = computed((): SearchFormDataType => store.state.searchMask as SearchFormDataType);
	const selectedDestinationName = computed((): string => formData.value?.selectedGeoInventory?.Name ?? '');

	const selectedDestinationCount = computed((): number | null => {
		if (formData.value.deal || formData.value.sortingHotel === 'Discount') {
			return null;
		} else if (selectedDestinationName.value === '') {
			return store.state.searchMask ? formData.value.availableHotelCount : null;
		} else {
			return formData.value.selectedGeoInventory?.Count ?? null;
		}
	});

	const selectedDestinationCountLabel = computed(() =>
		selectedDestinationCount.value ? pluralize(selectedDestinationCount.value, HOTEL_LABELS.singular, HOTEL_LABELS.plural) : ''
	);

	return {
		selectedDestinationName,
		selectedDestinationCount,
		selectedDestinationCountLabel,
	};
}
